import { enableProdMode, inject, importProvidersFrom, provideAppInitializer } from '@angular/core';

import { environment } from '../environments/environment';
import { TranslationService } from './common/services/languages/translation.service';
import { ApiHandlerService } from './svpp/services/api-handler/api-handler.service';
import { ReportApiHandlerService } from './report/services/api-handler/api-handler.service';
import { ApiHandlerService as UserRoleApiHandlerService } from './user-role/services/api-handler/api-handler.service';
import { AdminApiHandlerService } from './admin/services/api-handler/api-handler.service';
import { VcmApiHandlerService } from './vcm/services/api-handler/api-handler.service';
import { AuthenticationService } from './authentication/authentication.service';
import { RuntimeEnvironmentService } from './services/runtime-environment.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslationCacheInterceptorService } from './common/services/languages/translation-cache-interceptor.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { DispatcherModule } from './store/dispatcher.module';
import { PortalMaterialModule } from './material.components.module';
import { LanguageModule } from './common/services/languages/language.module';
import { NgReduxModule } from '@angular-redux/store';
import { StoreModule } from './store/store.module';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AuthModule } from './auth/auth.module';
import { AdminModule } from './admin/admin.module';
import { ReportModule } from './report/report.module';
import { VcmModule } from './vcm/vcm.module';
import { UserRoleModule } from './user-role/user_role.module';
import { SVPPModule } from './svpp/svpp.module';
import { FileUploadModule } from 'ng2-file-upload';
import { AppComponent } from './app.component';


if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
  importProvidersFrom(
    AppRoutingModule,
    DispatcherModule,
    PortalMaterialModule,
    LanguageModule,
    NgReduxModule,
    StoreModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AuthModule,
    AdminModule,
    ReportModule,
    VcmModule,
    UserRoleModule,
    SVPPModule,
    FileUploadModule
  ),
    TranslationService,
    ApiHandlerService,
    ReportApiHandlerService,
    UserRoleApiHandlerService,
    AdminApiHandlerService,
    VcmApiHandlerService,
    AuthenticationService,
    RuntimeEnvironmentService,
    provideAppInitializer(() => inject(RuntimeEnvironmentService).initializeEnvironment()),
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TranslationCacheInterceptorService,
        multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
]
})
  .catch(err => console.error(err));

